import React, { useState } from "react";
import ApplicationStepper from "../index";
import CaretDown from "../../../../../../../assets/svg/icons/common/CaretDown";
import useSalesFormStore from "../../../../../../../stores/sales-form";
import styles from "./styles.module.scss";
import baseStyles from "../style.module.scss";

const stepMapper = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
  7: 5,
};

const ApplicationStepperMobile = ({
  sections,
  onSectionChange,
  step,
  isKurvDomain,
}) => {
  const stepperOpen = useSalesFormStore((state) => state.mobileStepperOpen);
  const toggleMobileStepperOpen = useSalesFormStore(
    (state) => state.toggleMobileStepperOpen,
  );
  const currentStep = sections.find((e) => e.step === step);

  const handleStepperCaretClick = () => {
    toggleMobileStepperOpen();
  };

  return (
    <div
      className={`${styles.stepperMobileContainer} ${stepperOpen ? styles.open : ""}`}
    >
      <div className={styles.currentStepTitleContainer}>
        <p className={styles.currentStepTitle}>Create app</p>
      </div>

      <div className={styles.currentStep}>
        <div
          className={styles.currentStepLabelContainer}
          style={{ display: stepperOpen ? "none" : "flex" }}
        >
          <div
            className={`${baseStyles.stepCircle} ${baseStyles.activeCircle}`}
          ></div>
          <span className={styles.currentStepLabel}>{currentStep?.label}</span>
        </div>
        <div
          className={`${styles.stepperMobile} ${stepperOpen ? styles.stepperMobileOpen : ""}`}
        >
          <ApplicationStepper
            sections={sections}
            onSectionChange={onSectionChange}
            step={step}
            isKurvDomain={isKurvDomain}
            mobile
          />
        </div>

        <div
          className={styles.currentStepNumber}
          onClick={handleStepperCaretClick}
        >
          <span className={styles.currentStepNumberLabel}>
            {stepMapper[step]}/{sections.length}
          </span>

          <CaretDown
            className={styles.currentStepNumberIcon}
            width={16}
            height={16}
          />
        </div>
      </div>
    </div>
  );
};

export default ApplicationStepperMobile;
